module.exports = function() {
  return new Worker(__webpack_public_path__ + "ab151a092d05c3c4.worker.js");
};